<template lang="html">
  <div class="wcc auth">
    <h2>Login<slot></slot></h2>
    <form class="wcc">
      <div class="wcc input-group">
        <label for="to">Email</label>
        <input v-model="email" @blur="$v.email.$touch()" @focus="commitInput" :class="{invalid: $v.email.$error}" type="text" name="email" id="email" autocomplete="email">
          <transition name="fade" mode="out-in">
            <p class="wcc error-text" v-if="$v.email.$dirty && !$v.email.email">That is not a valid email.</p>
            <p class="wcc error-text" v-else-if="$v.email.$dirty && !$v.email.required">This field is required.</p>
            <p class="wcc error-text" v-else-if="errors.EMAIL_NOT_FOUND">There is no user with this email.</p>
            <p class="wcc error-text" v-else-if="errors.USER_DISABLED">This user has been disabled.</p>
          </transition>
      </div>
      <div class="wcc input-group">
        <label for="to">Password</label>
        <input v-model="password" @blur="$v.password.$touch()" @focus="commitInput" :class="{invalid: $v.password.$error}" type="password" name="password" id="password" autocomplete="password">
        <transition name="fade" mode="out-in">
          <p class="wcc error-text" v-if="$v.password.$dirty && !$v.password.required">This field is required.</p>
          <p class="wcc error-text" v-if="$v.password.$dirty && !$v.password.minLength">Your password was longer.</p>
          <p class="wcc error-text" v-else-if="errors.INVALID_PASSWORD">Invalid password.</p>
        </transition>
      </div>

      <Button :invalid="$v.$anyError" :submitting="submitting" :value="'Login'" v-hammer:tap='login'></Button>
      <transition name="fade" mode="out-in">
        <div class="wcc reset-password" @click="resetPassword" v-if="!resetPasswordSent">
          Forgot Password
        </div>
        <div class="wcc reset-password" v-else>
          Check your email ~
        </div>
      </transition>
    </form>
  </div>
</template>
<script>
  import Button from '@/components/Button.vue'
  import { required, email, minLength } from 'vuelidate/lib/validators'
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        email: '',
        password: '',
        resetPasswordSent: ''
      }
    },
    computed: {
      ...mapState('auth', {
        errors: state => state.login.errors,
        submitting: state => state.login.submitting,
      })
    },
    validations: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      }
    },
    methods: {
      login() {
        if (!this.$v.$anyError && !this.submitting) {
          this.$store.dispatch('auth/login', {
            email: this.email,
            password: this.password,
            returnSecureToken: true
          })
        }
      },
      resetPassword() {
        this.$store.dispatch('auth/chooseResetPassword')
      },
      commitInput() {
        this.$store.dispatch('appInput/commitInput')
      }
    },
    mounted() {
      let vm = this
      window.addEventListener("keydown", function(e) {
        // So that, if no calculator feed is active, enter will submit
        if (e.key == 'Enter' && !vm.$store.state.appInput.boundData) {
          e.preventDefault()
          vm.login()
        }
      })
    },
    components: {
      Button
    }
  }
</script>
<style lang="scss">
.wcc.reset-password {
  color: $grey-400;
  text-align: center;
  margin-top: $spacing/2;
  cursor: pointer;
  transition-duration: $transition-duration;

  @media(hover: hover) {
    &:hover {
      color: $blue-400;
    }
  }
}
</style>